<template>
  <svg
    v-if="name === 'camera'"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="shrink-0"
    aria-hidden="true"
  >
    <path
      d="M4 8h3l1.5-2h7L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"
    />
    <circle cx="12" cy="13" r="4" />
  </svg>
  <svg
    v-else-if="name === 'image'"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="shrink-0"
    aria-hidden="true"
  >
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <circle cx="8.5" cy="9.5" r="1.5" />
    <polyline points="21 16 15 10 5 20" />
  </svg>
  <svg
    v-else-if="name === 'file'"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="shrink-0"
    aria-hidden="true"
  >
    <path d="M7 3h7l4 4v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
    <polyline points="14 3 14 8 19 8" />
  </svg>
  <svg
    v-else-if="name === 'sparkle'"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    :fill="color"
    class="shrink-0"
    aria-hidden="true"
  >
    <path
      d="M12 2l1.8 5.4L19 9l-5.2 1.6L12 16l-1.8-5.4L5 9l5.2-1.6L12 2zm7 12l.9 2.6L22 18l-2.1.6L19 21l-.9-2.4L16 18l2.1-1L19 14zm-14 2l.6 1.6L7 18l-1.4.4L5 20l-.6-1.6L3 18l1.4-.4L5 16z"
    />
  </svg>
  <svg
    v-else-if="name === 'pencil'"
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    :stroke="color"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="shrink-0"
    aria-hidden="true"
  >
    <path d="M13.5 3.5 L16.5 6.5 L7 16 L3 17 L4 13 Z" />
    <line x1="2" y1="19" x2="18" y2="19" />
  </svg>
  <svg
    v-else-if="name === 'chev'"
    width="10"
    height="14"
    viewBox="0 0 10 14"
    fill="none"
    :stroke="color"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="shrink-0"
    aria-hidden="true"
  >
    <polyline points="2 2 8 7 2 12" />
  </svg>
  <svg
    v-else-if="name === 'check'"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="shrink-0"
    aria-hidden="true"
  >
    <polyline points="4 12.5 10 18.5 20 6" />
  </svg>
</template>
<script setup lang="ts">
  defineProps<{
    name: 'camera' | 'image' | 'file' | 'sparkle' | 'pencil' | 'chev' | 'check';
    color: string;
  }>();
</script>
